export const CURRENCIES = {
  USD: {
    symbol: "$",
    name: "US Dollar",
  },
  CAD: {
    symbol: "CA$",
    name: "Canadian Dollar",
  },
  EUR: {
    symbol: "€",
    name: "Euro",
  },
  AED: {
    symbol: "AED",
    name: "United Arab Emirates Dirham",
  },
  AFN: {
    symbol: "Af",
    name: "Afghan Afghani",
  },
  ALL: {
    symbol: "ALL",
    name: "Albanian Lek",
  },
  AMD: {
    symbol: "AMD",
    name: "Armenian Dram",
  },
  ARS: {
    symbol: "AR$",
    name: "Argentine Peso",
  },
  AUD: {
    symbol: "AU$",
    name: "Australian Dollar",
  },
  AZN: {
    symbol: "man.",
    name: "Azerbaijani Manat",
  },
  BAM: {
    symbol: "KM",
    name: "Bosnia-Herzegovina Convertible Mark",
  },
  BDT: {
    symbol: "Tk",
    name: "Bangladeshi Taka",
  },
  BGN: {
    symbol: "BGN",
    name: "Bulgarian Lev",
  },
  BHD: {
    symbol: "BD",
    name: "Bahraini Dinar",
  },
  BIF: {
    symbol: "FBu",
    name: "Burundian Franc",
  },
  BND: {
    symbol: "BN$",
    name: "Brunei Dollar",
  },
  BOB: {
    symbol: "Bs",
    name: "Bolivian Boliviano",
  },
  BRL: {
    symbol: "R$",
    name: "Brazilian Real",
  },
  BWP: {
    symbol: "BWP",
    name: "Botswanan Pula",
  },
  BYN: {
    symbol: "Br",
    name: "Belarusian Ruble",
  },
  BZD: {
    symbol: "BZ$",
    name: "Belize Dollar",
  },
  CDF: {
    symbol: "CDF",
    name: "Congolese Franc",
  },
  CHF: {
    symbol: "CHF",
    name: "Swiss Franc",
  },
  CLP: {
    symbol: "CL$",
    name: "Chilean Peso",
  },
  CNY: {
    symbol: "CN¥",
    name: "Chinese Yuan",
  },
  COP: {
    symbol: "CO$",
    name: "Colombian Peso",
  },
  CRC: {
    symbol: "₡",
    name: "Costa Rican Colón",
  },
  CVE: {
    symbol: "CV$",
    name: "Cape Verdean Escudo",
  },
  CZK: {
    symbol: "Kč",
    name: "Czech Republic Koruna",
  },
  DJF: {
    symbol: "Fdj",
    name: "Djiboutian Franc",
  },
  DKK: {
    symbol: "Dkr",
    name: "Danish Krone",
  },
  DOP: {
    symbol: "RD$",
    name: "Dominican Peso",
  },
  DZD: {
    symbol: "DA",
    name: "Algerian Dinar",
  },
  // EEK: {
  //   symbol: "Ekr",
  //   name: "Estonian Kroon",
  // },
  EGP: {
    symbol: "EGP",
    name: "Egyptian Pound",
  },
  ERN: {
    symbol: "Nfk",
    name: "Eritrean Nakfa",
  },
  ETB: {
    symbol: "Br",
    name: "Ethiopian Birr",
  },
  GBP: {
    symbol: "£",
    name: "British Pound Sterling",
  },
  GEL: {
    symbol: "GEL",
    name: "Georgian Lari",
  },
  GHS: {
    symbol: "GH₵",
    name: "Ghanaian Cedi",
  },
  GNF: {
    symbol: "FG",
    name: "Guinean Franc",
  },
  GTQ: {
    symbol: "GTQ",
    name: "Guatemalan Quetzal",
  },
  HKD: {
    symbol: "HK$",
    name: "Hong Kong Dollar",
  },
  HNL: {
    symbol: "HNL",
    name: "Honduran Lempira",
  },
  HRK: {
    symbol: "kn",
    name: "Croatian Kuna",
  },
  HUF: {
    symbol: "Ft",
    name: "Hungarian Forint",
  },
  IDR: {
    symbol: "Rp",
    name: "Indonesian Rupiah",
  },
  ILS: {
    symbol: "₪",
    name: "Israeli New Sheqel",
  },
  INR: {
    symbol: "Rs",
    name: "Indian Rupee",
  },
  IQD: {
    symbol: "IQD",
    name: "Iraqi Dinar",
  },
  IRR: {
    symbol: "IRR",
    name: "Iranian Rial",
  },
  ISK: {
    symbol: "Ikr",
    name: "Icelandic Króna",
  },
  JMD: {
    symbol: "J$",
    name: "Jamaican Dollar",
  },
  JOD: {
    symbol: "JD",
    name: "Jordanian Dinar",
  },
  JPY: {
    symbol: "¥",
    name: "Japanese Yen",
  },
  KES: {
    symbol: "Ksh",
    name: "Kenyan Shilling",
  },
  KHR: {
    symbol: "KHR",
    name: "Cambodian Riel",
  },
  KMF: {
    symbol: "CF",
    name: "Comorian Franc",
  },
  KRW: {
    symbol: "₩",
    name: "South Korean Won",
  },
  KWD: {
    symbol: "KD",
    name: "Kuwaiti Dinar",
  },
  KZT: {
    symbol: "KZT",
    name: "Kazakhstani Tenge",
  },
  LBP: {
    symbol: "LB£",
    name: "Lebanese Pound",
  },
  LKR: {
    symbol: "SLRs",
    name: "Sri Lankan Rupee",
  },
  // LTL: {
  //   symbol: "Lt",
  //   name: "Lithuanian Litas",
  // },
  // LVL: {
  //   symbol: "Ls",
  //   name: "Latvian Lats",
  // },
  LYD: {
    symbol: "LD",
    name: "Libyan Dinar",
  },
  MAD: {
    symbol: "MAD",
    name: "Moroccan Dirham",
  },
  MDL: {
    symbol: "MDL",
    name: "Moldovan Leu",
  },
  MGA: {
    symbol: "MGA",
    name: "Malagasy Ariary",
  },
  MKD: {
    symbol: "MKD",
    name: "Macedonian Denar",
  },
  MMK: {
    symbol: "MMK",
    name: "Myanma Kyat",
  },
  MOP: {
    symbol: "MOP$",
    name: "Macanese Pataca",
  },
  MUR: {
    symbol: "MURs",
    name: "Mauritian Rupee",
  },
  MXN: {
    symbol: "MX$",
    name: "Mexican Peso",
  },
  MYR: {
    symbol: "RM",
    name: "Malaysian Ringgit",
  },
  MZN: {
    symbol: "MTn",
    name: "Mozambican Metical",
  },
  NAD: {
    symbol: "N$",
    name: "Namibian Dollar",
  },
  NGN: {
    symbol: "₦",
    name: "Nigerian Naira",
  },
  NIO: {
    symbol: "C$",
    name: "Nicaraguan Córdoba",
  },
  NOK: {
    symbol: "Nkr",
    name: "Norwegian Krone",
  },
  NPR: {
    symbol: "NPRs",
    name: "Nepalese Rupee",
  },
  NZD: {
    symbol: "NZ$",
    name: "New Zealand Dollar",
  },
  OMR: {
    symbol: "OMR",
    name: "Omani Rial",
  },
  PAB: {
    symbol: "B/.",
    name: "Panamanian Balboa",
  },
  PEN: {
    symbol: "S/.",
    name: "Peruvian Nuevo Sol",
  },
  PHP: {
    symbol: "₱",
    name: "Philippine Peso",
  },
  PKR: {
    symbol: "PKRs",
    name: "Pakistani Rupee",
  },
  PLN: {
    symbol: "zł",
    name: "Polish Zloty",
  },
  PYG: {
    symbol: "₲",
    name: "Paraguayan Guarani",
  },
  QAR: {
    symbol: "QR",
    name: "Qatari Rial",
  },
  RON: {
    symbol: "RON",
    name: "Romanian Leu",
  },
  RSD: {
    symbol: "din.",
    name: "Serbian Dinar",
  },
  RUB: {
    symbol: "RUB",
    name: "Russian Ruble",
  },
  RWF: {
    symbol: "RWF",
    name: "Rwandan Franc",
  },
  SAR: {
    symbol: "SR",
    name: "Saudi Riyal",
  },
  SDG: {
    symbol: "SDG",
    name: "Sudanese Pound",
  },
  SEK: {
    symbol: "Skr",
    name: "Swedish Krona",
  },
  SGD: {
    symbol: "S$",
    name: "Singapore Dollar",
  },
  SOS: {
    symbol: "Ssh",
    name: "Somali Shilling",
  },
  SYP: {
    symbol: "SY£",
    name: "Syrian Pound",
  },
  THB: {
    symbol: "฿",
    name: "Thai Baht",
  },
  TND: {
    symbol: "DT",
    name: "Tunisian Dinar",
  },
  TOP: {
    symbol: "T$",
    name: "Tongan Paʻanga",
  },
  TRY: {
    symbol: "TL",
    name: "Turkish Lira",
  },
  TTD: {
    symbol: "TT$",
    name: "Trinidad and Tobago Dollar",
  },
  TWD: {
    symbol: "NT$",
    name: "New Taiwan Dollar",
  },
  TZS: {
    symbol: "TSh",
    name: "Tanzanian Shilling",
  },
  UAH: {
    symbol: "₴",
    name: "Ukrainian Hryvnia",
  },
  UGX: {
    symbol: "USh",
    name: "Ugandan Shilling",
  },
  UYU: {
    symbol: "$U",
    name: "Uruguayan Peso",
  },
  UZS: {
    symbol: "UZS",
    name: "Uzbekistan Som",
  },
  // VEF: {
  //   symbol: "Bs.F.",
  //   name: "Venezuelan Bolívar",
  // },
  VND: {
    symbol: "₫",
    name: "Vietnamese Dong",
  },
  XAF: {
    symbol: "FCFA",
    name: "CFA Franc BEAC",
  },
  XOF: {
    symbol: "CFA",
    name: "CFA Franc BCEAO",
  },
  YER: {
    symbol: "YR",
    name: "Yemeni Rial",
  },
  ZAR: {
    symbol: "R",
    name: "South African Rand",
  },
  // ZMK: {
  //   symbol: "ZK",
  //   name: "Zambian Kwacha",
  // },
  ZWL: {
    symbol: "ZWL$",
    name: "Zimbabwean Dollar",
  },
};
